// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1dpiy","loaderOuter":"PageOverlayLoader_loaderOuter__3A7_B"};